import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import { ApplicationProvider } from './context/ApplicationContext';
import { ProjectProvider } from './context/ProjectContext';


ReactDOM.createRoot(document.getElementById('root')).render(
  <BrowserRouter>
    <ApplicationProvider>
      <ProjectProvider>
      <App />
      </ProjectProvider>
    </ApplicationProvider>    
  </BrowserRouter>
);
 